/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Try_AgainInputs */

const en_ui_error_try_again = /** @type {(inputs: Ui_Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const de_ui_error_try_again = /** @type {(inputs: Ui_Error_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nochmal versuchen`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Ui_Error_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_try_again = /** @type {((inputs?: Ui_Error_Try_AgainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Try_AgainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_try_again(inputs)
	return de_ui_error_try_again(inputs)
});